module.exports = __webpack_public_path__ + "static/media/pilar_pemberdayaan_perempuan.fb87106a.jpg";